var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdownSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.102 12h11.796a1.5 1.5 0 0 1 1.13 2.488l-5.899 6.74a1.5 1.5 0 0 1-2.117.142c-.073-.068-.073-.068-.14-.142l-5.899-6.74A1.5 1.5 0 0 1 10.103 12z"
})));
export default SvgDropdownSmall;